export default "__VITE_ASSET__D73DVVHb__"